export default `
  mutation addEnterpriseMember($email: String!, $payerUserId: String, $enterpriseCustomerId: String) {
    addEnterpriseMember(email: $email, payerUserId: $payerUserId, enterpriseCustomerId: $enterpriseCustomerId) {
      success
      message
    }
  }
`
